import {Avatar, ListItem, ListItemAvatar, ListItemText} from "@mui/material";
import {ErrorOutline, HourglassTop, QuestionMark, TaskOutlined, Approval, UploadFile} from "@mui/icons-material";
import {SubmissionStateDto, SubmissionStateType} from "../../../client/submission/SubmissionApiClient";
import {SubmissionStateTypeFormatter} from "../SubmissionStateTypeFormatter";
import {useTranslation} from "react-i18next";
import {DateTimeFormatter} from "../../../common/DateTimeFormatter";
import {formatUserLastNameFirst} from "../../user/UserFormatter";
import {SystemStyleObject} from "@mui/system";
import {Theme} from "@mui/material/styles/createTheme";

const TYPE_TO_ICON_MAP  = new Map([
    [SubmissionStateType.ADDITIONAL_EXTRACTION_INFORMATION_OBTAINED, TaskOutlined],
    [SubmissionStateType.AUTHORIZATION_INITIALIZATION_FAILED, ErrorOutline],
    [SubmissionStateType.AUTHORIZATION_IN_PROGRESS, Approval],
    [SubmissionStateType.AUTHORIZED, Approval],
    [SubmissionStateType.CERTIFICATION_GENERATED, TaskOutlined],
    [SubmissionStateType.CERTIFICATION_SIGNED, TaskOutlined],
    [SubmissionStateType.DELIVERY_TO_EXTERNAL_SYSTEM_INITIALIZED, HourglassTop],
    [SubmissionStateType.METADATA_EXTRACTED, TaskOutlined],
    [SubmissionStateType.METADATA_EXTRACTION_FAILED, ErrorOutline],
    [SubmissionStateType.NOT_AUTHORIZED, ErrorOutline],
    [SubmissionStateType.OBTAINING_ADDITIONAL_EXTRACTION_INFORMATION, HourglassTop],
    [SubmissionStateType.PAYMENT_INFORMATION_CREATION_FAILED, ErrorOutline],
    [SubmissionStateType.PAYMENT_INFORMATION_PROCESSED, TaskOutlined],
    [SubmissionStateType.PROCESSED, TaskOutlined],
    [SubmissionStateType.SUPPORTING_DOCUMENTS_CREATED, TaskOutlined],
    [SubmissionStateType.SUPPORTING_DOCUMENTS_CREATION_FAILED, ErrorOutline],
    [SubmissionStateType.SUPPORTING_DOCUMENTS_TIMESTAMPED, TaskOutlined],
    [SubmissionStateType.UNPROCESSABLE, ErrorOutline],
    [SubmissionStateType.UPLOADED, UploadFile],
    [SubmissionStateType.VALIDATED, TaskOutlined],
    [SubmissionStateType.WAITING_FOR_AUTHORIZATION, HourglassTop],
    [SubmissionStateType.WAITING_FOR_DELIVERY_INITIALIZATION, HourglassTop],
    [SubmissionStateType.WAITING_FOR_METADATA_EXTRACTION, HourglassTop],
    [SubmissionStateType.WAITING_FOR_VALIDATION, HourglassTop]
]);

export interface SubmissionStateListItemProps {
    state: SubmissionStateDto;
    isActive: boolean;
}

export default function SubmissionStateListItem(props: Readonly<SubmissionStateListItemProps>) {
    const {state, isActive} = props;

    const {t} = useTranslation();

    const Icon = TYPE_TO_ICON_MAP.get(state.type.code as SubmissionStateType) ?? QuestionMark;
    const primaryText = SubmissionStateTypeFormatter.formatSubmissionStateType(state.type, t);
    const secondaryText = DateTimeFormatter.formatDateTime(state.triggeredAt) + " | " + formatUserLastNameFirst(state.triggeredBy);

    function buildAvatarStyle(isActive: boolean, theme: Theme): SystemStyleObject<Theme> {
        return isActive ? {backgroundColor: theme.palette.primary.main} : {};
    }

    return (
        <ListItem>
            <ListItemAvatar>
                <Avatar sx={(theme) => buildAvatarStyle(isActive, theme)}>
                    <Icon />
                </Avatar>
            </ListItemAvatar>
            <ListItemText primary={primaryText} secondary={secondaryText}/>
        </ListItem>
    );
}
